import { Injectable } from '@angular/core';
import { AppConfig, UvExplorerClient } from 'common';
import { Observable, Subject } from 'rxjs/Rx';
import { ValueEncoder, Guid } from "DiscoveryEngine.TS/Utils";
import { List } from "DiscoveryEngine.TS/Utils";
import { DeviceFilter } from 'DiscoveryEngine.TS/Core';
import { MonitorPolicy } from 'DiscoveryEngine.TS/Monitors';
import {
	DisplayDeviceListDto, GetAgentMonitorPoliciesResultDto, GetMonitorStateResultDto,
	GetDeviceStateResultDto, GetMapDeviceStateResultDto, InfoSetView, GetMonitorDeviceStatesResultDto
} from 'UvExplorerServer.Dtos.TS/Session';
//import { DisplayMonitorPolicyListDto } from 'UvExplorerServer.Dtos.TS/Session';
import { UpdateResultDto, AgentMonitorPolicyDto } from 'UvExplorerServer.Dtos.TS';
import { ObjSerUtils } from 'DiscoveryEngine.TS/Serialization';
import {
	DefaultMonitorSettingsFactory,
	DefaultMonitorSettingsEntryFactory
} from 'DiscoveryEngine.TS/Monitors';


@Injectable()
export class MonitorWebService {
	constructor(private appConfig: AppConfig, private uvExplorerClient: UvExplorerClient) {
		DefaultMonitorSettingsFactory.Initialize();
		DefaultMonitorSettingsEntryFactory.Initialize();
	}

	public addDevicesToAgentMonitorNetwork(sessionGuid: string, netViewGuid: string,
		agentGuid: string, schedDiscGuid: string, schedDiscRsltGuid: string,
		deviceGuids: string[]): Observable<boolean> {

		let deviceGuidValues = [];
		deviceGuids.forEach(dg => {
			deviceGuidValues.push({value: dg});
		}, this);

		let body = {
			agent_monitor_network_request: {
				session_guid: sessionGuid,
				net_view_guid: netViewGuid,
				agent_guid: agentGuid,
				sched_disc_guid: schedDiscGuid,
				sched_disc_result_guid: schedDiscRsltGuid,
				device_guids: deviceGuidValues
			}
		};

		let url = this.appConfig.sessionServiceUrl + `api/session/monitornetworks`;
		return this.uvExplorerClient.postNoResult(url, body);
	}

	public removeDevicesFromAgentMonitorNetwork(sessionGuid: string, netViewGuid: string,
		agentGuid: string, schedDiscGuid: string, schedDiscRsltGuid: string,
		deviceGuids: string[]): Observable<boolean> {

		let deviceGuidValues = [];
		deviceGuids.forEach(dg => {
			deviceGuidValues.push({value: dg});
		}, this);

		let body = {
			agent_monitor_network_request: {
				session_guid: sessionGuid,
				net_view_guid: netViewGuid,
				agent_guid: agentGuid,
				sched_disc_guid: schedDiscGuid,
				sched_disc_result_guid: schedDiscRsltGuid,
				device_guids: deviceGuidValues
			}
		};

		let url = this.appConfig.sessionServiceUrl + `api/session/monitornetworks`;
		return this.uvExplorerClient.deleteNoResult(url, body);
	}

	public updateDevicesInAgentMonitorNetwork(sessionGuid: string, netViewGuid: string,
		agentGuid: string, schedDiscGuid: string, schedDiscRsltGuid: string,
		deviceGuids: string[]): Observable<boolean> {

		let deviceGuidValues = [];
		deviceGuids.forEach(dg => {
			deviceGuidValues.push({ value: dg });
		}, this);

		let body = {
			agent_monitor_network_request: {
				session_guid: sessionGuid,
				net_view_guid: netViewGuid,
				agent_guid: agentGuid,
				sched_disc_guid: schedDiscGuid,
				sched_disc_result_guid: schedDiscRsltGuid,
				device_guids: deviceGuidValues
			}
		};

		let url = this.appConfig.sessionServiceUrl + `api/session/monitornetworks`;
		return this.uvExplorerClient.putNoResult(url, body);
	}

	public getAgentMonitorPolicies(sessionGuid: string, netViewGuid: string, agentGuid: string,
		schedDiscGuid: string, schedDiscRsltGuid: string, monitorPolicyGuids: List<string>,
		includeMonPolicies: boolean, includeMonPolicyStates: boolean)
			: Observable<GetAgentMonitorPoliciesResultDto> {

		let body = {
			get_agent_monitor_policies_request: {
				session_guid: sessionGuid,
				net_view_guid: netViewGuid,
				agent_guid: agentGuid,
				sched_disc_guid: schedDiscGuid,
				sched_disc_result_guid: schedDiscRsltGuid,
				monitor_policy_guids: [],
				include_monitor_policies: ValueEncoder.EncodeBoolean(includeMonPolicies),
				include_monitor_policy_states: ValueEncoder.EncodeBoolean(includeMonPolicyStates)
			}
		};

		if (!!monitorPolicyGuids) {
			ObjSerUtils.WriteStringValueCollection(
				body.get_agent_monitor_policies_request.monitor_policy_guids, monitorPolicyGuids, {});
		}

		let url = this.appConfig.sessionServiceUrl + `api/session/agentmonitorpolicies`;
		return this.uvExplorerClient.postObjSer<GetAgentMonitorPoliciesResultDto>(url, body, GetAgentMonitorPoliciesResultDto);
	}

	public createAgentMonitorPolicy(sessionGuid: string, netViewGuid: string, agentGuid: string,
		schedDiscGuid: string, schedDiscRsltGuid: string, monitorType: string): Observable<UpdateResultDto> {

		let body = {
			create_agent_monitor_policy_request: {
				session_guid: sessionGuid,
				net_view_guid: netViewGuid,
				agent_guid: agentGuid,
				sched_disc_guid: schedDiscGuid,
				sched_disc_result_guid: schedDiscRsltGuid,
				monitor_type: monitorType,
			}
		};

		let url = this.appConfig.sessionServiceUrl + `api/session/agentmonitorpolicy`;
		return this.uvExplorerClient.postObjSer<UpdateResultDto>(url, body, UpdateResultDto);
	}

	public deleteAgentMonitorPolicy(sessionGuid: string, netViewGuid: string, agentGuid: string,
		schedDiscGuid: string, schedDiscRsltGuid: string, policyGuid: string): Observable<boolean> {

		let body = {
			delete_agent_monitor_policy_request: {
				session_guid: sessionGuid,
				net_view_guid: netViewGuid,
				agent_guid: agentGuid,
				sched_disc_guid: schedDiscGuid,
				sched_disc_result_guid: schedDiscRsltGuid,
				monitor_policy_guid: policyGuid,
			}
		};

		let url = this.appConfig.sessionServiceUrl + `api/session/agentmonitorpolicy`;
		return this.uvExplorerClient.deleteNoResult(url, body);
	}

	public enableAgentMonitorPolicy(sessionGuid: string, netViewGuid: string, agentGuid: string,
		schedDiscGuid: string, schedDiscRsltGuid: string, policyGuid: string,
		enabled: boolean): Observable<UpdateResultDto> {

		let body = {
			enable_agent_monitor_policy_request: {
				session_guid: sessionGuid,
				net_view_guid: netViewGuid,
				agent_guid: agentGuid,
				sched_disc_guid: schedDiscGuid,
				sched_disc_result_guid: schedDiscRsltGuid,
				monitor_policy_guid: policyGuid,
				enabled: ValueEncoder.EncodeBoolean(enabled),
			}
		};

		let url = this.appConfig.sessionServiceUrl + `api/session/enableagentmonitorpolicy`;
		return this.uvExplorerClient.putObjSer(url, body, UpdateResultDto);
	}

	public updateAgentMonitorPolicy(sessionGuid: string, netViewGuid: string, agentGuid: string,
		schedDiscGuid: string, schedDiscRsltGuid: string, policy: AgentMonitorPolicyDto):
			Observable<UpdateResultDto> {

		let body = {
			update_agent_monitor_policy_request: {
				session_guid: sessionGuid,
				net_view_guid: netViewGuid,
				agent_guid: agentGuid,
				sched_disc_guid: schedDiscGuid,
				sched_disc_result_guid: schedDiscRsltGuid,
				removed_device_guids: [],
			}
		};

		policy.Write(body.update_agent_monitor_policy_request, {});

		policy.MonitorPolicy.RemovedDeviceGuids.ForEach((value: Guid) => {
			body.update_agent_monitor_policy_request.removed_device_guids.push(
				{ value: ValueEncoder.EncodeGuid(value) });
		});

		let url = this.appConfig.sessionServiceUrl + `api/session/updateagentmonitorpolicy`;
		return this.uvExplorerClient.putObjSer(url, body, UpdateResultDto);
	}

	public getMonitorState(sessionGuid: string, netViewGuid: string, agentGuid: string,
		schedDiscGuid: string, schedDiscRsltGuid: string, policy: MonitorPolicy)
		: Observable<GetMonitorStateResultDto> {

		let body = {
			get_monitor_state_request: {
				session_guid: sessionGuid,
				net_view_guid: netViewGuid,
				agent_guid: agentGuid,
				sched_disc_guid: schedDiscGuid,
				sched_disc_result_guid: schedDiscRsltGuid,
			}
		};

		policy.Write(body.get_monitor_state_request, {});

		let url = this.appConfig.sessionServiceUrl + `api/session/monitorstate`;
		return this.uvExplorerClient.post<GetMonitorStateResultDto>(url, body);
	}

	public getMonitorDeviceList(sessionGuid: string, netViewGuid: string, agentGuid: string,
		schedDiscGuid: string, schedDiscRsltGuid: string): Observable<DisplayDeviceListDto> {

		let body = {
			get_monitor_device_list_request: {
				session_guid: sessionGuid,
				net_view_guid: netViewGuid,
				agent_guid: agentGuid,
				sched_disc_guid: schedDiscGuid,
				sched_disc_result_guid: schedDiscRsltGuid,
			}
		};

		let url = this.appConfig.sessionServiceUrl + `api/session/monitordevicelist`;
		return this.uvExplorerClient.post<DisplayDeviceListDto>(url, body);
	}

	public getDeviceState(sessionGuid: string, netViewGuid: string, agentGuid: string,
		schedDiscGuid: string, schedDiscRsltGuid: string, deviceGuid: string)
		: Observable<GetDeviceStateResultDto> {

		let body = {
			get_device_state_request: {
				session_guid: sessionGuid,
				net_view_guid: netViewGuid,
				agent_guid: agentGuid,
				sched_disc_guid: schedDiscGuid,
				sched_disc_result_guid: schedDiscRsltGuid,
				device_guid: deviceGuid,
			}
		};

		let url = this.appConfig.sessionServiceUrl + `api/session/devicestate`;
		return this.uvExplorerClient.post<GetDeviceStateResultDto>(url, body);
	}

	public getMonitorDeviceStates(sessionGuid: string, netViewGuid: string, agentGuid: string,
		schedDiscGuid: string, schedDiscRsltGuid: string, policy: MonitorPolicy)
		: Observable<GetMonitorDeviceStatesResultDto> {

		let body = {
			get_monitor_device_states_request: {
				session_guid: sessionGuid,
				net_view_guid: netViewGuid,
				agent_guid: agentGuid,
				sched_disc_guid: schedDiscGuid,
				sched_disc_result_guid: schedDiscRsltGuid,
			}
		};

		policy.Write(body.get_monitor_device_states_request, {});

		let url = this.appConfig.sessionServiceUrl + `api/session/monitordevicestates`;
		return this.uvExplorerClient.post<GetMonitorDeviceStatesResultDto>(url, body);
	}

	public getMapDeviceState(sessionGuid: string, netViewGuid: string, agentGuid: string,
		schedDiscGuid: string, schedDiscRsltGuid: string, deviceGuids: string[])
		: Observable<GetMapDeviceStateResultDto> {

		let body = {
			get_map_device_state_request: {
				session_guid: sessionGuid,
				net_view_guid: netViewGuid,
				agent_guid: agentGuid,
				sched_disc_guid: schedDiscGuid,
				sched_disc_result_guid: schedDiscRsltGuid,
				device_guids: [],
			}
		};
		deviceGuids.forEach((guid: string) => {
			body.get_map_device_state_request.device_guids.push({ value: guid });
		});

		let url = this.appConfig.sessionServiceUrl + `api/session/mapdevicestate`;
		return this.uvExplorerClient.post<GetMapDeviceStateResultDto>(url, body);
	}

	public clearMonitorHistory(sessionGuid: string, netViewGuid: string, agentGuid: string,
		schedDiscGuid: string, schedDiscRsltGuid: string,
		policyGuid: string, deviceGuid: string): Observable<boolean> {

		let body = {
			clear_monitor_history_request: {
				session_guid: sessionGuid,
				net_view_guid: netViewGuid,
				agent_guid: agentGuid,
				sched_disc_guid: schedDiscGuid,
				sched_disc_result_guid: schedDiscRsltGuid,
				monitor_policy_guid: policyGuid,
				device_guid: deviceGuid,
			}
		};

		let url = this.appConfig.sessionServiceUrl + `api/session/clearmonitorhistory`;
		return this.uvExplorerClient.putNoResult(url, body);
	}

	public getMonitorHistory(sessionGuid: string, netViewGuid: string, agentGuid: string,
		schedDiscGuid: string, schedDiscRsltGuid: string,
		monitorType: string, policyGuid: string, deviceGuid: string): Observable<InfoSetView> {

		let body = {
			get_monitor_history_request: {
				session_guid: sessionGuid,
				net_view_guid: netViewGuid,
				agent_guid: agentGuid,
				sched_disc_guid: schedDiscGuid,
				sched_disc_result_guid: schedDiscRsltGuid,
				monitor_type: monitorType,
				monitor_policy_guid: policyGuid,
				device_guid: deviceGuid,
			}
		};

		let url = this.appConfig.sessionServiceUrl + `api/session/monitorhistory`;
		return this.uvExplorerClient.post<InfoSetView>(url, body);
	}

}